import { Component, OnInit } from '@angular/core';
import { AppSettingsService } from '../../shared/app-settings/app-settings.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
	selector: 'app-services',
	templateUrl: './services.component.html',
	styleUrls: ['./services.component.css'],
})
export class ServicesComponent implements OnInit {

  public templateCounter: number = this.appSettings.data.user.count_new_templates;

  public services = [{
    link: this.getLinkWithAccountSettings('http://verstka.lpgenerator.ru/?ch=st&utm_source=st&utm_medium=dashboard&utm_campaign=header'),
    title: this.translate.instant('Услуги верстки'),
    ico: 'makeup',
    width: 56
  }, {
    link: 'http://lpgenerator.ru/landing-page-design-store/',
    title: this.translate.instant('Магазин лендингов'),
    ico: 'shop',
    width: 56
  }];

  constructor(
    private appSettings: AppSettingsService,
    private translate: TranslateService
  ) {  }

  public getLinkWithAccountSettings(link: string): string {
    const user = this.appSettings.data.user;
    const accountParams = `name=${user.first_name}&email=${user.email}&phone=${user.phone}`;
    return `${link}&${accountParams}`;
  }

  ngOnInit() {

  }

}



// WEBPACK FOOTER //
// /srv/projects/jsapp/src/app/core/services/services.component.ts